<template>
</template>
<script>
    import AlignmentMixin from "../../../author/pagesbuilder/mixins/AlignmentMixin";
    import BackgroundMediaMixin from "../../../author/pagesbuilder/mixins/BackgroundMediaMixin";

    export default {
        name: "ColumnElement",
        mixins: [
            BackgroundMediaMixin,
            AlignmentMixin
        ],
        data() {
            return {
                elementType: 'column',
            }
        },
        computed: {
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    linkData: {},
                    selectedMedia: "",
                    imageMediaData : null,
                    responsiveAlignmentClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    itemVisibilitySettings: null
                }
            },
        },
        methods: {
            showImage () {
                this.toggleBgImageDisplay(true);
            },
            showColor () {
                this.toggleColorOnlyDisplay(true);
            }
        }
    }
</script>
